import type { AnimationDataV9 } from './types/v9';
import type { AnimationDataV10 } from './types/v10';

/** V9 → V10: `Shot` gains an optional `voiceoverUuid`; old saves just bump the version. */
export function v9ToV10(input: AnimationDataV9): AnimationDataV10 {
    return { ...input, version: 10 };
}
